export default __webpack_public_path__ + "static/media/index.f1fb0a72.less";